import {isNil} from 'ramda';

import {FinancingMoney} from '../types/FinancingMoney';
import {areDecimalValuesEqual} from './areDecimalValuesEqual';

/**
 * Compares two money values by currency and by decimal amount, so `30` and `30.00` count as the
 * same amount.
 */
export function areMoneyValuesEqual(left: FinancingMoney, right: FinancingMoney) {
  if (isNil(left) || isNil(right)) {
    return isNil(left) && isNil(right);
  }

  return left.currency === right.currency && areDecimalValuesEqual(left.amount, right.amount);
}
